import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { TableHeader } from '@/ui/typography/company-info';
import { SmallText } from '@/ui/typography/widgets';
import { Highlight, remapEmphasizedTextToDOMElement } from './suggestion-utils';

export const SuggestionContent = ({
  name,
  type,
  listingsCount,
  highlights,
  contentComponent,
}: {
  name: string;
  type: string;
  listingsCount?: number;
  highlights?: string[];
  contentComponent?: React.ReactNode;
}) => {
  const { t } = useTranslation('default', {
    keyPrefix: 'globalSearch',
  });

  return (
    <ThreePartContainer
      name="suggestion-content-container"
      fullWidth
      gap="15px"
    >
      <LeftSection
        name="suggestion-name-and-highlights"
        direction="column"
        gap="4px"
      >
        <Flexbox name="suggestion-name-and-type-container" gap="8px">
          <Header>{name}</Header>
          {listingsCount ? (
            <ListingsCount>
              {listingsCount} {t('companies', { count: listingsCount })}
            </ListingsCount>
          ) : null}
        </Flexbox>
        {!contentComponent && highlights
          ? highlights.map(h => (
              <Highlight key={h}>
                {remapEmphasizedTextToDOMElement(h)}
              </Highlight>
            ))
          : null}
      </LeftSection>

      {contentComponent}

      <RightSection>
        <SuggestionType>{t(type)}</SuggestionType>
      </RightSection>
    </ThreePartContainer>
  );
};

const ThreePartContainer = styled(Flexbox)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

const LeftSection = styled(Flexbox)`
  flex: 1;
  min-width: 0;
`;

const RightSection = styled('div')`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

const SuggestionType = styled(SmallText)`
  color: ${({ theme }) => theme.colors.gray.c10};
`;

const ListingsCount = styled(TableHeader)`
  text-wrap: nowrap;
  width: max-content;
`;

const Header = styled(SmallText)`
  color: ${({ theme }) => theme.colors.basics.black};
`;
